<script setup lang="ts">
import type { GoodsItemAdminRecord } from '@/api/modules/goodsConfig'
import type { TradeOrderItem } from '@/api/modules/trade'
import type { ProTableColumn } from '@/components/FaProTable/types'
import { FaButton } from '@fantastic-admin/components'
import FaProTable from '@/components/FaProTable/index.vue'
import { formatDateTime } from '../../utils/userDisplay'

defineOptions({ name: 'UserC2cTab' })

const props = defineProps<{
  userId: number
  goods: { list: GoodsItemAdminRecord[], total: number }
  buyerOrders: { list: TradeOrderItem[], total: number }
  sellerOrders: { list: TradeOrderItem[], total: number }
  canViewGoods: boolean
  canViewOrders: boolean
}>()
const emit = defineEmits<{ navigate: [path: string, query: Record<string, number>] }>()

const goodsColumns: ProTableColumn<GoodsItemAdminRecord>[] = [
  { prop: 'id', label: '商品 ID', width: 90 },
  { prop: 'title', label: '商品', minWidth: 250 },
  { prop: 'price', label: '价格', width: 110, formatter: row => `¥${Number(row.price || 0).toFixed(2)}` },
  { prop: 'display_status', label: '状态', width: 120 },
  { prop: 'created_at', label: '发布时间', width: 170, formatter: row => formatDateTime(row.created_at) },
]
const orderColumns: ProTableColumn<TradeOrderItem>[] = [
  { prop: 'order_no', label: '订单号', minWidth: 200 },
  { prop: 'goods_title_snapshot', label: '商品', minWidth: 220 },
  { prop: 'pay_price', label: '实付', width: 110, formatter: row => `¥${Number(row.pay_price || 0).toFixed(2)}` },
  { prop: 'order_status', label: '订单状态', width: 140 },
  { prop: 'created_at', label: '创建时间', width: 170, formatter: row => formatDateTime(row.created_at) },
]
</script>

<template>
  <div class="space-y-4">
    <FaCard title="在售与历史商品" content-class="pt-3">
      <div class="mb-3 flex items-center justify-between">
        <span class="text-sm text-muted-foreground">共 {{ goods.total }} 件</span><FaButton v-if="props.canViewGoods" variant="outline" size="sm" @click="emit('navigate', '/goods/item', { seller_user_id: props.userId })">
          进入商品列表
        </FaButton>
      </div>
      <FaProTable :columns="goodsColumns" :data="goods.list" :show-toolbar="false" :show-pagination="false" :bordered="false" row-key="id" />
    </FaCard>
    <div class="gap-4 grid xl:grid-cols-2">
      <FaCard title="作为买家" content-class="pt-3">
        <div class="mb-3 flex items-center justify-between">
          <span class="text-sm text-muted-foreground">共 {{ buyerOrders.total }} 笔</span>
          <FaButton v-if="props.canViewOrders" variant="outline" size="sm" @click="emit('navigate', '/trade/order', { buyer_user_id: props.userId })">
            进入订单列表
          </FaButton>
        </div>
        <FaProTable :columns="orderColumns" :data="buyerOrders.list" :show-toolbar="false" :show-pagination="false" :bordered="false" row-key="id" />
      </FaCard>
      <FaCard title="作为卖家" content-class="pt-3">
        <div class="mb-3 flex items-center justify-between">
          <span class="text-sm text-muted-foreground">共 {{ sellerOrders.total }} 笔</span>
          <FaButton v-if="props.canViewOrders" variant="outline" size="sm" @click="emit('navigate', '/trade/order', { seller_user_id: props.userId })">
            进入订单列表
          </FaButton>
        </div>
        <FaProTable :columns="orderColumns" :data="sellerOrders.list" :show-toolbar="false" :show-pagination="false" :bordered="false" row-key="id" />
      </FaCard>
    </div>
  </div>
</template>
